import axios from "axios";

const BASEURL =
  "https://portal.monetare.com.br/rest/34/iogdg1j75ottqddw/crm.deal.add.json?CATEGORIA_ID=16";

function formatarParaAmericanoCustom(dateStr) {
  // Verifica se a string está no formato correto
  if (!/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
    return "";
  }

  const [year, month, day] = dateStr.split("-");
  return `${month}/${day}/${year}`;
}

const BitrixFunilApi = ({
  nomeCompleto,
  cpf,
  dataNascimento,
  email,
  telefone,
  linkSimulacao,
  cgi,
  valorImovel,
  valorFinanciamento,
}) => {
  function verifyProduct(product) {
    return product === "FIN" ? "544" : "556";
  }
  axios
    .post(BASEURL, {
      fields: {
        TITLE: nomeCompleto, //Nome do cliente
        UF_CRM_1741712188: formatarParaAmericanoCustom(dataNascimento),
        UF_CRM_1741712150: cpf, //cpf
        CATEGORY_ID: 16, // Pípeline de Simulação
        STAGE_ID: "C16:NEW", // etapa
        OPPORTUNITY: valorFinanciamento, // valor de financiamento
        UF_CRM_1741712562: valorImovel, //valor do imovel
        UF_CRM_1741712357: "+55" + telefone, //celular
        UF_CRM_1741712215: email, //email
        UF_CRM_1742499977: verifyProduct(cgi), //556
        UF_CRM_1741714407: linkSimulacao !== "" ? "" : "528",
        UF_CRM_1745959439391: linkSimulacao,
        UF_CRM_1742567081: "354812", // INDICA QUE ESTA VINDO PELO SITE 354812
        COMPANY_ID: "8322"//AUTEM
      },
    })
    .then(() => { })
    .catch(() => { })
    .finally(() => { });
};

export default BitrixFunilApi;
